import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_HUS
export default class Facturacion {
  getDataFacturacion (payload = {}) {
    return http.get(`${baseUrl}/operaciones/facturacion`, {
      params: payload,
      headers: {
        loading: true
      }
    })
  }

  getDetalleFacturacion (payload = {}) {
    return http.get(`${baseUrl}/operaciones/facturacion-detalle`, {
      params: payload,
      headers: {
        loading: true
      }
    })
  }
}
